export * from './PersonaText';
